import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b291e22a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-outline mb-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "sharingType"
}, "Project sharing", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "tab-navigation mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-row align-items-end"
}
const _hoisted_6 = { class: "form-outline mb-4 flex-grow-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "link"
}, "Share link", -1))
const _hoisted_8 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "orthomosaic-embed"
}, "Embed map (orthomosaic)", -1))
const _hoisted_11 = { class: "d-flex flex-row align-items-start" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "model-embed"
}, "Embed model (3D textured mesh / point cloud)", -1))
const _hoisted_15 = { class: "d-flex flex-row align-items-start" }
const _hoisted_16 = ["value"]

import ModalDialog from "@/components/Modals/ModalDialog.vue";
import VueSelect from "vue-select";
import { useAppStateStore } from "@/store/app-state";
import { useDataStore } from "@/store/data-store";
import { UpdateProjectInputSharingEnum } from "@/swagger";
import { reactive, computed, ref } from "vue";
import { ViewIndex } from "@/classes/data-structures/view-index";
import { LayerItemType } from "@/classes/data-structures/layer-item-type";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareProjectDialog',
  setup(__props, { expose }) {

const dataStore = useDataStore();
const appState = useAppStateStore();
const activeTab = ref("link");

const shareLink = computed(() => {
	return window.location.href;
})

// Generate embed URLs for iframe
const orthomosaicEmbedUrl = computed(() => {
    const baseUrl = window.location.origin;
    const projectId = appState.project?.uuid;
    const surveyId = appState.view1Survey?.uuid || appState.project?.surveys?.[0]?.uuid;
    
    if (projectId && surveyId) {
        // Get visible orthophoto and CAD layers
        const visibleOrthos = appState.getViewLayers(ViewIndex.View1, LayerItemType.Orthophoto)
            .filter(layer => layer.visible)
            .map(layer => layer.id);

        const visibleCadLayers = appState.getViewLayers(ViewIndex.View1, LayerItemType.Cad)
            .filter(layer => layer.visible)
            .map(layer => layer.id);

        const visibleLayers = [...visibleOrthos, ...visibleCadLayers];
        
        let url = `${baseUrl}/native/view/${projectId}/${surveyId}`;
        
        // Add visible layers as a query parameter if there are any
        if (visibleLayers.length > 0) {
            url += `?layers=${visibleLayers.join(",")}`;
        }
        
        return url;
    }
    return "";
});

const modelEmbedUrl = computed(() => {
    const baseUrl = window.location.origin;
    const projectId = appState.project?.uuid;
    const surveyId = appState.view1Survey?.uuid || appState.project?.surveys?.[0]?.uuid;
    
    if (projectId && surveyId) {
        // Get visible 3D layers (meshes, point clouds, and CAD)
        const visibleMeshes = appState.getViewLayers(ViewIndex.View1, LayerItemType.Meshes)
            .filter(layer => layer.visible)
            .map(layer => layer.id);
            
        const visiblePointClouds = appState.getViewLayers(ViewIndex.View1, LayerItemType.PointClouds)
            .filter(layer => layer.visible)
            .map(layer => layer.id);
            
        const visibleCadLayers = appState.getViewLayers(ViewIndex.View1, LayerItemType.Cad)
            .filter(layer => layer.visible)
            .map(layer => layer.id);
            
        // Combine all visible 3D layers
        const allVisibleLayers = [...visibleMeshes, ...visiblePointClouds, ...visibleCadLayers];
        
        let url = `${baseUrl}/native/view/${projectId}/${surveyId}`;
        
        // Add visible layers as a query parameter if there are any
        if (allVisibleLayers.length > 0) {
            url += `?layers=${allVisibleLayers.join(",")}`;
        }
        
        return url;
    }
    return "";
});

// Generate iframe HTML code
const orthomosaicEmbedCode = computed(() => {
    if (!orthomosaicEmbedUrl.value) return "";
    return `<iframe width="100%" style="aspect-ratio: 16/9;" src="${orthomosaicEmbedUrl.value}"></iframe>`;
});

const modelEmbedCode = computed(() => {
    if (!modelEmbedUrl.value) return "";
    return `<iframe width="100%" style="aspect-ratio: 16/9;" src="${modelEmbedUrl.value}"></iframe>`;
});

let data = reactive({
	show: false,
	sharingOptions: [{
		label: "Only you can view the project",
		value: UpdateProjectInputSharingEnum.None
	}, {
		label: "Anyone with link can view project",
		value: UpdateProjectInputSharingEnum.AnyoneCanView
	}]
})

function show() {
	data.show = true;
    activeTab.value = "link";
}

function hide() {
	data.show = false;
}

async function setSharing(sharing: UpdateProjectInputSharingEnum) {
	console.log("Sharing:", sharing);
	await dataStore.updateProject(appState.project.uuid, undefined, undefined, undefined, sharing);
	await appState.reloadCurrentProject();
}

function copyLinkToClipboard() {
    copyToClipboard(shareLink.value);
}

function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
        // Optional: Show success message
        console.log("Copied to clipboard");
    }).catch(() => {
        // Fallback for older browsers
        const el = document.createElement("textarea");
        el.value = text;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
    });
}

expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: "Share project"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(VueSelect), {
            class: "underlined",
            modelValue: _unref(appState).project.sharing,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(appState).project.sharing) = $event)),
            reduce: option => option.value,
            clearable: false,
            options: _unref(data).sharingOptions,
            "onOption:selected": _cache[1] || (_cache[1] = ($event: any) => (setSharing(_unref(appState).project.sharing)))
          }, null, 8, ["modelValue", "reduce", "options"])
        ]),
        (_unref(appState).project.sharing == _unref(UpdateProjectInputSharingEnum).AnyoneCanView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: _normalizeClass(["tab-button", { active: activeTab.value === 'link' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'link'))
                }, " LINK ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["tab-button", { active: activeTab.value === 'embed' }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (activeTab.value = 'embed'))
                }, " ⟨⟩ EMBED ", 2)
              ]),
              (activeTab.value === 'link')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _withDirectives(_createElementVNode("input", {
                        name: "link",
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(shareLink) ? (shareLink).value = $event : null)),
                        disabled: "true"
                      }, null, 512), [
                        [_vModelText, _unref(shareLink)]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "btn mb-4 ms-3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (copyLinkToClipboard()))
                    }, "Copy link")
                  ]))
                : _createCommentVNode("", true),
              (activeTab.value === 'embed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("textarea", {
                          id: "orthomosaic-embed",
                          class: "form-control font-monospace",
                          rows: "2",
                          value: _unref(orthomosaicEmbedCode),
                          readonly: ""
                        }, null, 8, _hoisted_12),
                        _createElementVNode("button", {
                          class: "btn ms-3",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (copyToClipboard(_unref(orthomosaicEmbedCode))))
                        }, "Copy")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("textarea", {
                          id: "model-embed",
                          class: "form-control font-monospace",
                          rows: "2",
                          value: _unref(modelEmbedCode),
                          readonly: ""
                        }, null, 8, _hoisted_16),
                        _createElementVNode("button", {
                          class: "btn ms-3",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (copyToClipboard(_unref(modelEmbedCode))))
                        }, "Copy")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "mt-4" }, [
          _createElementVNode("button", {
            class: "btn-link me-4",
            onClick: hide
          }, "Close")
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})